import React, { useRef } from 'react';
import { useActivitiesViewModel } from '../../../viewModels/useActivitiesViewModel';
import ActivityUsage from './ActivityUsage';
import ActivityFilters from './ActivityFilters';
import ActivityTable from './ActivityTable';
import '../Library/Library.css'; // the page root and panel
import '../Settings/Scenarios/Scenarios.css'; // the section title
import './Activities.css';

/**
 * Activities (Navy Phase 0 handoff, `renderActivities`): token usage above the
 * Activity log, which carries the audit trail, since Phase 0 has no separate
 * Audit Log. The log reads only: nothing in it is editable, deletable or
 * archivable, so the page raises no toasts.
 */
function Activities({ model }) {
  const vm = useActivitiesViewModel(model);
  const searchRef = useRef(null);
  const { filters, visibleEntries } = vm;

  const handleClear = () => {
    vm.clearSearchAndFilters();
    searchRef.current?.focus();
  };

  return (
    <div className="library activities">
      <ActivityUsage usage={vm.usage} scope={vm.usageScope} onScopeChange={vm.setUsageScope} />

      <section className="activities-section" aria-labelledby="activities-log-title">
        <h2 id="activities-log-title" className="scenarios-title activities-title">Activity log</h2>
        <div className="library-panel">
          <ActivityFilters
            filters={filters}
            empty={!visibleEntries.length}
            searchRef={searchRef}
            onFilterChange={vm.setFilter}
            onClear={handleClear}
          />
          <ActivityTable
            entries={visibleEntries}
            sort={vm.sort}
            onSortChange={vm.setSort}
            resetKey={`${filters.search}|${filters.range}|${filters.category}`}
          />
        </div>
      </section>
    </div>
  );
}

export default Activities;
